import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RestrictInputDirective } from '@shared/directives/restrict-input.directive';
import { AuthorizationDirective } from '@shared/directives/authorization.directive';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RestrictInputDirective,
    AuthorizationDirective
  ],
  exports: [
    RestrictInputDirective,
    AuthorizationDirective
  ]
})
export class SharedDirectivesModule { }
